import { AnimateSlideInContent } from '@components/animation/AnimateSlideIn/index.style'
import { colors } from '@styles/vars/colors.style'
import { cubicBezier } from '@styles/vars/cubicBezier.style'
import { roundedCorners } from '@utils'
import styled from 'styled-components'
import { mq } from '@styles/vars/media-queries.style'

const overlayTransitionDuration = 0.4

export const VideoMain = styled.div`
  position: relative;
  aspect-ratio: 16 / 9;

  ${AnimateSlideInContent} {
    display: block;
    width: 100%;
    height: 100%;
  }

  iframe {
    width: 100%;
    height: 100%;
    aspect-ratio: 16 / 9;
  }
  > div {
    pointer-events: none;
  }
  ${mq.tabletPMax} {
    aspect-ratio: ${props => props.hasOverlay ? "unset": "16 / 9"};
    height: ${props => props.hasOverlay ? "520px": "auto"};
  }
  button + div {
    display: ${props => props.grid ? 'none' : ''};
  }
`

export const VideoOverlay = styled.button`
  position: absolute;
  top: -0.2rem;
  right: -0.2rem;
  bottom: -0.2rem;
  left: -0.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  pointer-events: ${props => (props.playing ? 'none' : undefined)};
  appearance: none;
  border: none;
  background-color: ${props => props.hasOverlay ? colors.charcoal : 'transparent'};
  opacity: ${props => (props.playing ? props.grid ? 1 : 0 : 1)};
  transition: opacity ${overlayTransitionDuration}s ${cubicBezier.inOut};
  width: 100%;
  .gatsby-image-wrapper {
    width: 100%;
    height: 100%;
    position: relative;
    &:after {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      height: 100%;
      width: 100%;
      background: rgba(0,0,0,0.8);
      display: ${props => props.hasOverlay ? 'block' : 'none'};
    }
  }
`
